import { useState } from "react";
import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import {
  BORDER,
  BORDER_LIGHT,
  FOCUS_RING,
  INK,
  OVERDUE_BG,
  OVERDUE_FG,
  TEXT_MUTED,
} from "../../Utils/designTokens";
import { PHONE_MASK, PHONE_MASK_CHARS } from "../Login/phone";

/**
 * CRL-3241 `.phone-input`: fixed "+90" prefix, national number typed as
 * "5XX XXX XX XX", 56px tall, 14px radius, focus ring; the error text sits
 * below in a reserved line (`.field__err`) so the layout never jumps.
 */
export default function RHFPhoneInput({
  name,
  control,
  label,
  errors,
  onFocus,
  onBlur,
}: any) {
  const [isFocused, setIsFocused] = useState(false);
  const message: string | undefined = errors?.[name]?.message;
  const showError = !isFocused && !!message;

  const borderColor = showError ? OVERDUE_FG : isFocused ? INK : BORDER;
  const ring = showError
    ? `0 0 0 4px ${OVERDUE_BG}`
    : isFocused
      ? `0 0 0 4px ${FOCUS_RING}`
      : "none";

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur: fieldOnBlur, value } }) => (
        <div className="w-full">
          <div
            className="flex items-center h-14 rounded-[14px] bg-white"
            style={{
              border: `1.5px solid ${borderColor}`,
              boxShadow: ring,
              transition: "border-color .15s, box-shadow .15s",
            }}
          >
            <span
              className="flex items-center h-6 pl-4 pr-3 mr-3 text-[15px] font-semibold"
              style={{ color: TEXT_MUTED, borderRight: `1px solid ${BORDER_LIGHT}` }}
            >
              +90
            </span>
            <InputMask
              mask={PHONE_MASK}
              formatChars={PHONE_MASK_CHARS}
              maskChar={null}
              value={value ?? ""}
              onChange={(e) => onChange(e.target.value)}
              onBlur={() => {
                setIsFocused(false);
                fieldOnBlur();
                if (onBlur) onBlur();
              }}
              onFocus={() => {
                setIsFocused(true);
                if (onFocus) onFocus();
              }}
            >
              {/* @ts-ignore react-input-mask v2 render-prop child */}
              {(inputProps: any) => (
                <input
                  {...inputProps}
                  name={name}
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel-national"
                  placeholder="5XX XXX XX XX"
                  aria-label={label}
                  className="flex-1 min-w-0 h-full pr-4 bg-transparent border-0 outline-none text-[16px] font-medium tracking-[0.4px] placeholder:font-normal placeholder:tracking-normal placeholder:text-[#94A3B8]"
                  style={{ color: INK }}
                />
              )}
            </InputMask>
          </div>
          <div
            className="mt-[7px] min-h-[16px] text-[12.5px]"
            style={{ color: OVERDUE_FG }}
            aria-live="polite"
          >
            {showError ? message : ""}
          </div>
        </div>
      )}
    />
  );
}
